import { r2Fetch } from './client';

export interface R2BucketCreateParams {
  bucket_id: string;
}

export interface R2BucketCreateResponse {
  name: string;
  creation_date: string;
}

export async function r2BucketCreate(
  params: R2BucketCreateParams
): Promise<R2BucketCreateResponse> {
  return r2Fetch<R2BucketCreateResponse>('/rpc/r2_bucket_create', {
    body: params,
  });
}
